import axios from 'axios';
import { useState, useEffect } from 'react';
import { userCount } from './../../../../api/api';


const UserCount = ({ refresh, onRefresh }) => {

     const [userList, setUserList] = useState([]);


     const getUserCount = async () => {
          const res = await axios.get(userCount)
          setUserList(res.data)
     }

     useEffect(() => {
          getUserCount()
     }, []);

     useEffect(() => {
          getUserCount()
          onRefresh()
     }, [refresh]);


     return (
          <ul>
               {userList && userList.map(i => (
                    <li key={i.roleName}>{i.roleName} : <span>{i.count}</span></li>
               ))}
          </ul>
     )
}
export default UserCount